import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent {

  userForm!: FormGroup;

  private readonly currentUser = JSON.parse(localStorage.getItem('current_user') || "");

  constructor(private formBuilder: FormBuilder, private authService: AuthService, private toastr: ToastrService, private router: Router,) {

  }

  ngOnInit(): void {

    this.userForm = this.formBuilder.group({
      username: [this.currentUser.username, Validators.required],
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmNewPassword: ['', Validators.required],
    });
  }

  changePassword(): void {

    if (this.userForm.invalid) {
      this.toastr.error('Please fill all mandatory fields.', 'Error');
      return;
    }

    if (this.userForm.valid) {
      const pwdData = this.userForm.value;

      this.authService.changePassword(pwdData).subscribe({
        next: response => {
          if (response.message) {
            this.toastr.success(response.message, 'Success');
            this.onReset();
            this.router.navigate(['/dashboard']);
          } else {
            this.toastr.error('Password change failed, Please try again.');
          }
        },
        error: error => {
          console.log(error);
          this.toastr.error(error.error.message, 'Error');
        }
      });
    }

  }

  onReset(): void {
    this.userForm.reset();
    this.router.navigate(['/dashboard']);
  }

}
